import { Maybe } from "@flockcover/flock-svc-core-types"
import { SpeedBands, Trip } from "../../api/insights"
import { getSpeedBands } from "../../api/insights/utils"
import { VehicleData, VehicleScore } from "../types"
import { calculateScoreChange } from "../../utils"

export type CompletedTripsData = Omit<Trip, "analytics" | "vehicle"> & {
  rowIndex: number
  safeMiles: Maybe<number>
  speedBands: Maybe<SpeedBands>
  unsafeMiles: Maybe<number>
  vehicle: VehicleData
  vehicleScore: VehicleScore
}

export const makeTripData = (trips: ReadonlyArray<Trip>): ReadonlyArray<CompletedTripsData> =>
  trips.map((trip, rowIndex) => {
    const { speedBands } = trip.analytics
    return {
      ...trip,
      safeMiles: trip.analytics.safeMiles,
      unsafeMiles: trip.analytics.unsafeMiles,
      speedBands: getSpeedBands(
        speedBands?.minorSpeedBandPercentage ?? null,
        speedBands?.majorSpeedBandPercentage ?? null,
        speedBands?.criticalSpeedBandPercentage ?? null
      ),
      vehicle: {
        vrn: trip.vehicle.vrn,
        name: trip.vehicle.name,
      },
      vehicleScore: {
        score: trip.vehicle.currentPeriod?.score ?? null,
        change: calculateScoreChange(trip.vehicle.currentPeriod?.score, trip.vehicle.previousPeriodScore),
      },
      rowIndex,
    }
  })
